import { feedbackDataTwo } from "@/db/feedbackDataTwo";
import FeedbackClient from "./feedbackClient";

const FeedbackTwo = () => {
  return (
    <div className="testimonials-area ptb-120">
      <div className="container">
        <div className="section-title text-center">
          <h2 className="fs-3 fw-semibold mx-auto mb-0 text-uppercase">
            In Their Own Words: Student Feedback
          </h2>
        </div>
      </div>
      <FeedbackClient feedbackDataTwo={feedbackDataTwo} />
    </div>
  );
};

export default FeedbackTwo;
